import catalogModule from '../../catalog/catalogModule';

function searchOptionsController($log, $scope, catalogConstants, constantsService) {
    "ngInject";


    $scope.canToggleSubmenu = function (category) {
        const { subcategories, categoryId } = category;
        return subcategories && subcategories.length > 0
            && (!$scope.currentQuery.category || $scope.currentQuery.category.categoryId !== categoryId);
    }
}

catalogModule.controller("searchOptionsController", searchOptionsController);

export default searchOptionsController;